var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "122px",
    height: "117px",
    viewBox: "0 0 122 117",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "316ED6D5-782E-4793-B838-C169719E5262") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty-States",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK---General-Empty",
    transform: "translate(-134.000000, -246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "general-empty-state-info",
    transform: "translate(24.000000, 246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-box-illustration",
    transform: "translate(110.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.2842103,57.7168211 L62.2842103,116.452631 L26.7062916,103.349566 C21.0998746,101.284767 17.4215686,95.88964 17.5477998,89.9164188 L18.1679119,60.5729121 C18.3312744,52.8426515 24.7303202,46.7084687 32.4605807,46.8718312 C34.1220947,46.9069437 35.7640854,47.2376052 37.3096824,47.8483355 L62.2842103,57.7168211 L62.2842103,57.7168211 Z",
    id: "Path-11-Copy",
    fill: "#00CFE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2842103,57.7168211 L62.2842103,116.452631 L98.023298,103.434091 C103.552146,101.420118 107.231579,96.1638823 107.231579,90.2796455 L107.231579,60.8272056 C107.231579,53.0952191 100.963565,46.8272056 93.2315786,46.8272056 C91.5153937,46.8272056 89.8138348,47.1427502 88.2117636,47.7581024 L62.2842103,57.7168211 L62.2842103,57.7168211 Z",
    id: "Path-12-Copy",
    fill: "#04DDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2842103,58.1046895 L76.7263507,75.53317 C79.0379299,78.3227365 82.9356192,79.2106837 86.2273926,77.697638 L112.013794,65.8450586 C116.028299,63.9998132 117.786831,59.249547 115.941586,55.235042 C115.592966,54.4765868 115.12779,53.7773662 114.562943,53.1627619 L103.471932,41.0947367 L103.471932,41.0947367 L62.2842103,58.1046895 Z",
    id: "Path-14-Copy",
    fill: "#00ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.563607,40.4526314 L115.04395,23.0721179 C117.479084,19.3854794 116.464539,14.4228024 112.7779,11.9876685 C112.222691,11.6209362 111.623896,11.3249041 110.99539,11.1064309 L84.8297357,2.01105877 C81.41565,0.824297706 77.6298904,2.07417337 75.5935278,5.06041024 L62.9263156,23.6363241 L62.9263156,23.6363241 L103.563607,40.4526314 Z",
    id: "Path-15-Copy",
    fill: "#00ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6421051,23.7371602 L47.7016553,6.91557984 C45.5417838,4.30931882 41.9753998,3.34446596 38.7961135,4.50626629 L13.333041,13.8111869 C9.1831655,15.3276677 7.04837736,19.9211571 8.5648582,24.0710325 C8.88786336,24.9549416 9.36429351,25.7749267 9.97223899,26.4932789 L21.7861166,40.4526314 L21.7861166,40.4526314 L61.6421051,23.7371602 Z",
    id: "Path-16-Copy",
    fill: "#00ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2842103,57.5183546 L47.8165016,75.9382172 C45.5291008,78.8504688 41.5419653,79.8122143 38.1784146,78.2630407 L10.7623782,65.6358493 C6.74929416,63.7875157 4.99441717,59.0358979 6.84275073,55.0228139 C7.27141009,54.0921128 7.8748752,53.2524272 8.62033852,52.5494068 L21.4474226,40.4526314 L21.4474226,40.4526314 L62.2842103,57.5183546 Z",
    id: "Path-17-Copy",
    fill: "#00ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2929295,57.5173945 L102.990788,42.3926323 C104.02298,41.9993706 104.540934,40.8438126 104.147673,39.8116212 C103.945387,39.2806846 103.526831,38.860842 102.996517,38.6569294 L63.2953741,23.3913194 C62.834071,23.2139423 62.3234284,23.2136507 61.861923,23.3905008 L22.2104346,38.5850577 C21.1790021,38.9803054 20.6632724,40.1368582 21.0585201,41.1682907 C21.2616318,41.6983278 21.6803976,42.1170936 22.2104346,42.3202052 L61.8652069,57.5160205 C62.3247377,57.692114 62.8330605,57.6926032 63.2929295,57.5173945 Z",
    id: "Path-13-Copy",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/empty-box.156b637ad724b01eecdee90308c721cc.svg";
export { ForwardRef as ReactComponent };